export default __webpack_public_path__ + "static/media/KanipakamdietieTwo.5baccae9.png";